module.exports = __webpack_public_path__ + "static/img/ptsj@2x.6fc8a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ptsj@2x.png
// module id = pcd4
// module chunks = 2